import { takeEvery } from 'redux-saga/effects'
import { submitCommentFormNewRoutine} from './comment_routines'
import {submitNewCommentForm} from './comment_new_saga'

const commentSagas = [
  takeEvery(submitCommentFormNewRoutine.TRIGGER, submitNewCommentForm)
]
export default commentSagas
